  import { motion } from "framer-motion";
  import { ArrowRight } from "lucide-react";
import Button from "@mui/material/Button";
import solarbattery from "../assets/solar-batteries.jpeg";
import "./Home.css";

function Home() {
  return (
    <>
      <section className="home">

        {/* Left Content */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ staggerChildren: 0.2 }}
        >
          <motion.h1
            initial={{ y: 30 }}
            animate={{ y: 0 }}
            className="home-title"
          >
            Clean Energy for a{" "}
            <span className="home-highlight">Brighter Tomorrow</span>
          </motion.h1>

          <motion.p
            initial={{ y: 20 }}
            animate={{ y: 0 }}
            className="home-text"
          >
            Smart, affordable solar solutions that help homes and businesses
            save energy and protect the planet.
          </motion.p>

          <motion.div initial={{ y: 10 }} animate={{ y: 0 }}>
            <Button
              variant="contained"
              color="success"
              className="home-button"
            >
              Get Started
              <motion.span whileHover={{ x: 6 }} style={{ display: "inline-flex", marginLeft: 8 }}>
                <ArrowRight size={16} />
              </motion.span>
            </Button>
          </motion.div>
        </motion.div>

        {/* Right Visual */}
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="home-visual"
        >
          <div className="home-glow" />
          <div className="home-card">
            <img src={solarbattery} alt="" style={{ borderRadius: "24px", boxShadow: "0 30px 60px rgba(0, 0, 0, 0.25)", width: "100%", height: "100%" }} />
          </div>
        </motion.div>

      </section>
      {/* <section className="home-bottom-bar">
        <div className="home-bar-item">
          <h3>5000+</h3>
          <p>Customers</p>
        </div>
        <div className="home-bar-item">
          <h3>1000+</h3>
          <p>Projects</p>
        </div>
        <div className="home-bar-item">
          <h3>500+</h3>
          <p>Employees</p>
        </div>
      </section> */}
      <section className="testimonials">
        <div className="container">
          <h2>Customer Testimonials</h2>
          <p className="subtitle">
            Trusted by homeowners and businesses across the region
          </p>

          <div className="testimonial-grid">
            <div className="testimonial-card">
              <p>
                “Solar made the entire solar installation process smooth and
                hassle-free. Our electricity bills have reduced by more than 60%.”
              </p>
              <h4>Rahul Mehta</h4>
              <span>Homeowner</span>
            </div>

            <div className="testimonial-card">
              <p>
                “Professional team, excellent support, and high-quality solar
                panels. A great investment for our business.”
              </p>
              <h4>Anjali Shah</h4>
              <span>Business Owner</span>
            </div>

            <div className="testimonial-card">
              <p>
                “From consultation to installation, everything was perfectly
                managed. Highly recommend Solar for solar solutions.”
              </p>
              <h4>Vikram Patel</h4>
              <span>Factory Manager</span>
            </div>
          </div>
        </div>
      </section>
      <section className="impact">
        <div className="impact-container">

          <h2>Our Impact</h2>
          <p className="impact-subtitle">
            Driving clean energy adoption and making a measurable difference
          </p>

          <div className="impact-grid">

            <div className="impact-card">
              <span className="impact-icon">⚡</span>
              <h3>10,000+</h3>
              <p>kW Solar Installed</p>
            </div>

            <div className="impact-card">
              <span className="impact-icon">🏡</span>
              <h3>1,200+</h3>
              <p>Happy Customers</p>
            </div>

            <div className="impact-card">
              <span className="impact-icon">🌱</span>
              <h3>15,000</h3>
              <p>Tons of CO₂ Reduced</p>
            </div>

            <div className="impact-card">
              <span className="impact-icon">⭐</span>
              <h3>98%</h3>
              <p>Customer Satisfaction</p>
            </div>

          </div>
        </div>
      </section>



    </>
  );
}

export default Home;
